import React from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import classNames from 'classnames';

import { IDataTableProperties } from './data-table-properties';

function DataTable({ isInitialized, dataTableOptions, ...properties }: IDataTableProperties) {
  const className = classNames('ag-theme-alpine', {
    'ag-theme-alpine--no-floating-filter': !dataTableOptions.showFloatingFilter,
  });

  if (!isInitialized) {
    return null;
  }
  return (
    <div className={className} style={{ height: '100%', width: '100%' }}>
      <AgGridReact {...properties} />
    </div>
  );
}

export default DataTable;
